import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { Drawer } from '@design-system/components/modal/sideModal';
import * as styles from './ProgramDrawerShell.css';

export type ProgramDrawerShellProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  testId?: string;
  children: ReactNode;
};

export const ProgramDrawerShell = ({
  isOpen,
  onClose,
  title,
  testId,
  children,
}: ProgramDrawerShellProps) => (
  <Drawer isOpen={isOpen} onClose={onClose}>
    <button
      type="button"
      className={styles.closeButton}
      onClick={onClose}
      aria-label="Close"
      data-testid={testId ? `${testId}-close` : undefined}
    >
      <FontAwesomeIcon icon={faTimes} className={styles.closeIcon} />
    </button>
    <div className={styles.container} data-testid={testId}>
      {isOpen ? (
        <>
          <h2 className={styles.title}>{title}</h2>
          {children}
        </>
      ) : null}
    </div>
  </Drawer>
);
